// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d712273f","453":"ee151c13","455":"7cbe3dc3","977":"b978e1ea"}[chunkId] + ".chunk.js";
};